import React from 'react';

export default ({isSuper, isAgent, userData, children}) => {
    // if is super user or agent user
    return isSuper || isAgent ?
        React.cloneElement(children, {isSuper, isAgent, userData})
        : (
        <div className='SuperAgent'>
            <h1>Not Authorized</h1>
            <p>Additional account permissions needed to view this page.</p>
        </div>
        )
}